import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { resetALL } from "Redux/actions";
import { clientMutation } from "Core/data/GraphQLApi";
import { endpoints } from "Core/defaultValues";
import { ExceptionManager } from "Core/logManager";

const INIT_STATE = {
    open: false,
    loading: false,
    loadingCreate: false,
    drivers: [],
    isEvent: false,
    error: null,
    eventIds: [], // structure DriverEventsInput in 
};

const route = 'modules/driverPerformance/views/driver/modals/createDriverCoaching/redux/slice';

const bulkCreateDriverPerformanceCasesFull = createAsyncThunk(
    "driverPerformance/driver/createDriverCoaching/bulkCreateDriverPerformanceCasesFull",
    async (payload, { rejectWithValue, getState }) => {
        try {
            const response = await clientMutation(
                bulkCreateDriverPerformanceCasesFull.query,
                payload,
                endpoints.GRAPHQL_GENERAL_V2
            );

            if (!response?.data) {
                throw 'bulkCreateDriverPerformanceCasesFull : No data found';
            }

            return response?.data;
        } catch (exc) {
            ExceptionManager(exc, route, "bulkCreateDriverPerformanceCasesFull");
            return rejectWithValue(exc);
        }
    }
);

bulkCreateDriverPerformanceCasesFull.query = `
    mutation bulkCreateDriverPerformanceCasesFull ($driverScope: Int!, $limitedBy: Int!, $eventCategories: Int!, $eventsLimit: Int!, $includeHighlight: Boolean!, $driverIds: [Int], $eventIds: [DriverEventsInput]) {
        data: bulkCreateDriverPerformanceCasesFull (driverScope: $driverScope, limitedBy: $limitedBy, eventCategories: $eventCategories, eventsLimit: $eventsLimit, includeHighlight: $includeHighlight, driverIds: $driverIds, eventIds: $eventIds) {
            stepFunctionId
            transactionId
            transactionType
            processStartDate
        }
    }`;

export { bulkCreateDriverPerformanceCasesFull };

//Slice
const driverPerformanceDriverTabCreateDriverCoachingRedux = createSlice({
    name: "driverPerformance/createDriverCoaching",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        },
        openModalCreateDriverCoaching: (state, action) => {
            state.open = action.payload.open;
            state.drivers = action?.payload?.drivers || [];
            state.isEvent = action?.payload?.isEvent || false;
            state.eventIds = action?.payload?.eventIds || [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        builder.addCase(bulkCreateDriverPerformanceCasesFull.pending, (state) => {
            state.loadingCreate = true;
            state.error = null;
        });
        builder.addCase(bulkCreateDriverPerformanceCasesFull.fulfilled, (state, action) => {
            state.loadingCreate = false;
            state.coaches = action.payload;
        });
        builder.addCase(bulkCreateDriverPerformanceCasesFull.rejected, (state, action) => {
            state.loadingCreate = false;
            state.error = action.payload;
        });
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = driverPerformanceDriverTabCreateDriverCoachingRedux;

// Extract and export each action creator by name
export const { openModalCreateDriverCoaching, reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
